import { useTranslation } from "react-i18next";
import React, { useState, useEffect, Fragment, useMemo, memo } from "react";
import { useNavigate } from "react-router-dom";
import apiRequest from "../../functions/api";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  MenuItem,
  Box,
  Hidden,
  Button,
  Grid,
  Tabs,
  Tab,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  Select,
  Autocomplete,
  IconButton,
  Tooltip,
  DialogTitle,
} from "@mui/material";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import ToDosAdmin from "../ToDosAdminComponent/ToDosAdmin";
import TextField from "@mui/material/TextField";
import { useMessage } from "../../context/message-context";
import Page from "../shared/components/PageComponent";
import Layout from "../shared/components/LayoutComponent";
import ResponsiveDialog from "../shared/components/ResponsiveDialog";
import MessageBox from "../shared/components/MessageBox";
import { AufgabenDesktop, AufgabenMobil, Erinnerungen, fetchAufgaben, postAufgabeErledigen } from ".";
import { useSessionStorage } from "../../utils/hooks";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";
import ToDosNew from "../ToDosNewComponent/ToDosNew";
import Interview from "../InterviewComponent";
import { SearchTextField } from "../lib";
import { FilterList } from "@mui/icons-material";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";

function ToDos() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [aufgaben, setAufgaben] = useState([]);
  const [filteredAufgaben, setFilteredAufgaben] = useState([]);
  const [pagedAufgaben, setPagedAufgaben] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [aktionenFilterOptionen, setAktionenFilterOptionen] = useState([]);
  const [selectedAktionenFilter, setSelectedAktionenFilter] = useState("ALLE");

  const [accessToken] = useSessionStorage(LOCAL_STORAGE_KEY.accessToken);
  const [offeneAufgaben, setOffeneAufgaben] = useSessionStorage(LOCAL_STORAGE_KEY.offeneAufgaben);
  const [dialog, setDialog] = useState(false);
  // const [accessToken, mandant] = props;
  const [uebersicht, setUebersicht] = useState(localStorage.getItem("WEBAGU_ANSICHT") ? Number(localStorage.getItem("WEBAGU_ANSICHT")) : 0);
  const [messageBoxOpen, setMessageBoxOpen] = useState(false);
  const [selectedAufgabe, setSelectedAufgabe] = useState(null);

  // Filter
  const storedFilterObject = JSON.parse(localStorage.getItem("WEBAGU_FILTER"));
  const [filter, setFilter] = useState(storedFilterObject?.filter ? storedFilterObject?.filter : "O");
  const [suche, setSuche] = useState(storedFilterObject?.suche ? storedFilterObject?.suche : "");
  const [datumsFilter, setDatumsFilter] = useState(storedFilterObject?.datumsFilter ? storedFilterObject?.datumsFilter : "");
  const [aufgabenartFilter, setAufgabenartFilter] = useState(storedFilterObject?.aufgabenartFilter ? storedFilterObject?.aufgabenartFilter : []);
  const [mandantFilter, setMandantFilter] = useState(storedFilterObject?.mandantFilter ? storedFilterObject?.mandantFilter : []);
  const [filterDialog, setFilterDialog] = useState(false);
  const [erledigtPage, setErledigtPagePage] = useState(1);
  const [maxPage, setMaxPage] = useState();
  const maxEntriesPerPage = 50;

  const { hideMessage, showErrorMessage } = useMessage();

  const mandantFilterOptions = useMemo(() => {
    // Herrausfiltern der einzelnen Optionen
    const tmpfilter = aufgaben
      ?.filter((value, index, array) => array.findIndex((element) => element.mandant === value.mandant) === index)
      .map((mapElement) => ({
        value: mapElement.mandant,
        label: mapElement.mandant,
        color: mapElement.color,
      }));
    if (tmpfilter === undefined) return [];
    return tmpfilter;
  }, [aufgaben]);

  const aufgabenArtFilterOptions = useMemo(() => {
    // Herrausfiltern der einzelnen Optionen
    const tmpfilter = aktionenFilterOptionen
      ?.filter((value, index, array) => array.findIndex((element) => element.key === value.key) === index)
      .map((mapElement) => {
        if (!mapElement?.status.includes(filter + ";")) {
          return null;
        }
        return {
          value: mapElement.key,
          label: mapElement.bezeichnung,
          color: mapElement.color,
        };
      })
      ?.filter((item) => item !== null);

    if (tmpfilter === undefined) return [];
    return tmpfilter;
  }, [aktionenFilterOptionen, filter]);

  const openMessageBox = () => {
    setMessageBoxOpen(true);
  };

  const closeMessageBox = () => {
    setMessageBoxOpen(false);
  };

  function messageBoxResult(r) {
    if (r === "OK") {
      aufgabeErledigen();
    }
    closeMessageBox();
  }

  useEffect(() => {
    setSelectedAktionenFilter("ALLE");
  }, [filter]);

  useEffect(() => {
    setPagedAufgaben([]);
    if (filter === "E") {
      const tmp_eAufgaben = filteredAufgaben?.filter((aufgabe) => aufgabe.status === "erledigt");
      if (tmp_eAufgaben?.length > maxEntriesPerPage) {
        const tmpPages = Math.ceil(tmp_eAufgaben.length / maxEntriesPerPage);
        setMaxPage(tmpPages);

        const startIndex = (erledigtPage - 1) * maxEntriesPerPage;
        const endIndex = startIndex + maxEntriesPerPage;

        const currentPageEntries = tmp_eAufgaben.slice(startIndex, endIndex);
        setPagedAufgaben(currentPageEntries);
      }
    }
  }, [filter, filteredAufgaben, erledigtPage]);

  useEffect(() => {
    if (uebersicht === 0) setFilter("O");
    if (uebersicht === 1) setFilter("E");
  }, [uebersicht]);

  useEffect(() => {
    // Die Änderung des filters einmal in localstorage schreiben
    const filterObject = {
      filter: filter,
      mandantFilter: mandantFilter,
      aufgabenartFilter: aufgabenartFilter,
      datumsFilter: datumsFilter,
      suche: suche,
    };
    if (filterObject) localStorage.setItem("WEBAGU_FILTER", JSON.stringify(filterObject));

    // Hier die Aufgaben filtern
    const result = aufgaben?.filter((item) => {
      const tmpMandant = mandantFilter?.length !== 0 ? mandantFilter.some((searchItem) => searchItem.value === item.mandant) : true;
      const tmpAufgaben = aufgabenartFilter?.length !== 0 ? aufgabenartFilter.some((searchItem) => searchItem.value === item.betreff) : true;
      const tmpSuche = suche?.trim() !== "" ? [item.bezeichnung, item.betreff].some((field) => field?.toLowerCase().includes(suche.toLowerCase())) : true;
      const datumEingestellt = () => {
        if (filter === "O") {
          return datumsFilter?.trim() !== ""
            ? [item.faellig_dat].some((field) => {
                if (field === "Kein Termin" || field === undefined) return false;
                return field.replace(/(\d{2})\.(\d{2})\.(\d{4})/, "$3$2$1") >= datumsFilter.replace(/-/g, "");
              })
            : true;
        } else {
          return datumsFilter?.trim() !== ""
            ? [item.datum].some((field) => field.replace(/(\d{2})\.(\d{2})\.(\d{4})/, "$3$2$1") === datumsFilter.replace(/-/g, ""))
            : true;
        }
      };

      return tmpMandant && tmpAufgaben && tmpSuche && datumEingestellt();
    });

    setFilteredAufgaben(result);
  }, [aufgaben, filter, mandantFilter, aufgabenartFilter, datumsFilter, suche]);

  const getAufgaben = () => {
    setIsLoading(true);
    fetchAufgaben(accessToken)
      .then((data) => {
        setAufgaben(data.aufgaben);
        setAktionenFilterOptionen(data.aktionenFilter);
        if (data.aufgabenCount) {
          setOffeneAufgaben(data.aufgabenCount);
        }
        hideMessage();
      })
      .catch((err) => {
        showErrorMessage(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
    // eslint-disable-next-line
  };

  useEffect(() => {
    getAufgaben();
  }, []);

  const aufgabeErledigen = () => {
    setIsLoading(true);
    postAufgabeErledigen(accessToken, selectedAufgabe.key)
      .then((data) => {
        setAufgaben(data.aufgaben);
        if (data.aufgabenCount) {
          setOffeneAufgaben(data.aufgabenCount);
        }
        hideMessage();
      })
      .catch((err) => {
        showErrorMessage(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const ansicht_aendern = (ansicht) => {
    localStorage.setItem("WEBAGU_ANSICHT", ansicht);
    setUebersicht(ansicht);
  };

  const hdok_aufgabe = (aktion) => {
    setDialog(false);
    if (aktion === "verschicken") {
      if (selectedAufgabe.art === "hvkt") {
        navigate("/LTERW2/?hvktKey=" + selectedAufgabe.key);
      }
      if (selectedAufgabe.art === "hauf") {
        navigate("/LTERW2/?haufKey=" + selectedAufgabe.key);
      }
    }
    if (aktion === "erledigen") {
      aufgabeErledigen(selectedAufgabe.key);
    }
  };

  const navigateToOrigin = (aufgabe) => {
    if (aufgabe.hdok !== "") {
      navigate("/GESEND?query=" + aufgabe.hdok_bez);
    } else {
      if (aufgabe.aktion === "HDBD") navigate("/WEBPDB/pflichtdoc/details/" + aufgabe.aktion_key.slice(0, 4));
      if (aufgabe.key === "Genehmigung_Fehlzeitenantrag") navigate("/PMURA3/protokoll");
    }
  };

  const handleAktion = (aufgabe) => {
    switch (aufgabe.aktion) {
      case "HDBD":
        navigate("/WEBPDB/pflichtdoc/confirm/" + aufgabe.aktion_key.slice(0, 4));
        break;
      case "WURG":
        navigate("/PMURA3/antragsdetails/" + aufgabe.mandant + "V" + aufgabe.aktion_key);
        break;
      case "WZKR":
        navigate("/PMURA3/korrekturdetails/" + aufgabe.mandant + "V" + aufgabe.aktion_key);
        break;
      case "XXXX":
        navigate("/WEBAGU/dynamisch/" + aufgabe.key);
        break;
      case "LFEP":
        navigate("/LTERW2/?hvktKey=" + aufgabe.key);
        break;
      case "CSLT":
        navigate("/WEBAGU/inviteKey/" + aufgabe.key);
        break;
      case "WSZA":
        navigate("/SPLANT/" + aufgabe.mandant + "V" + aufgabe.aktion_key);
        break;
      case "LHRZ":
        if (aufgabe.art === "hauf") {
          navigate("/LTERW2/?haufKey=" + aufgabe.key);
        } else {
          navigate("/LTERW2/?hvktKey=" + aufgabe.key);
        }
        break;
      case "WFGX":
        if (aufgabe.kz === "H") {
          navigate("/WEBAGU/formularInfo/" + aufgabe.mandant + "V" + aufgabe.key);
        }else{
        navigate("/FORMUL/genehmigen/" + aufgabe.aktion_key);  
        }        
        break;
      case "HABW":
        navigate("/WEBAGU/AuToDo/" + aufgabe.mandant + "V" + aufgabe.key);
        break;
      case "HDOK":
        navigate("/LTERW2/?haufKey=" + aufgabe.key);
        break;

      default:
        if (aufgabe.hdok !== "") {
          setDialog(true);
        } else {
          if (aufgabe.art === "hauf") {
            navigate("/WEBAGU/haufDynamisch/" + aufgabe.mandant + "V" + aufgabe.key);
          } else {
            openMessageBox();
          }
        }
    }
  };

  const handleAufgabeClick = (aufgabe) => {
    if (!aufgabe.status) return;
    if (aufgabe.status === "erledigt") {
      navigateToOrigin(aufgabe);
    } else {
      setSelectedAufgabe(aufgabe);
      handleAktion(aufgabe);
    }
  };

  if (isLoading) {
    return <LoadingComponent />;
  }

  const tabellen_head = () => {
    if (filter === "O") {
      return (
        <Fragment>
          <TableCell>{t("Bezeichnung")}</TableCell>
          <TableCell>{t("Mandant")}</TableCell>
          <TableCell>{t("Fällig")}</TableCell>
        </Fragment>
      );
    } else {
      return (
        <Fragment>
          <TableCell>{t("Bezeichnung")}</TableCell>
          <TableCell>{t("Mandant")}</TableCell>
          <TableCell>{t("zuletzt erledigt am")}</TableCell>
        </Fragment>
      );
    }
  };

  const TodoMain = () => {
    return (
      <>
        <Box sx={{ display: { xs: "block", sm: "block", md: "none" } }}>
          <TableContainer sx={{ maxHeight: window.innerHeight - 250 }}>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: "100%" }} />
                </TableRow>
              </TableHead>
              <TableBody>
                <AufgabenMobil
                  aufgaben={pagedAufgaben?.length > 0 ? pagedAufgaben : filteredAufgaben}
                  aktionFilter={selectedAktionenFilter}
                  filter={filter}
                  onAufgabeClick={handleAufgabeClick}
                />
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Box sx={{ display: { xs: "none", sm: "none", md: "block" } }}>
          <TableContainer sx={{ maxHeight: 950 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>{tabellen_head()}</TableRow>
              </TableHead>
              <TableBody>
                <AufgabenDesktop
                  aufgaben={pagedAufgaben?.length > 0 ? pagedAufgaben : filteredAufgaben}
                  aktionFilter={selectedAktionenFilter}
                  filter={filter}
                  onAufgabeClick={handleAufgabeClick}
                />
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <ResponsiveDialog
          title={t("Soll eine Datei verschickt werden?")}
          open={dialog}
          setOpen={(o) => {
            setDialog(false);
          }}
        >
          <Box p={1}>
            <Grid container justifyContent="center">
              <Grid item xs={12}>
                <Grid container justifyContent="center" spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Button variant="contained" color="primary" fullWidth onClick={() => hdok_aufgabe("verschicken")}>
                      {t("Datei versenden")}
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Button color="primary" variant="outlined" fullWidth onClick={() => hdok_aufgabe("erledigen")}>
                      {t("Aufgabe ohne hochladen erledigen")}
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </ResponsiveDialog>
      </>
    );
  };

  const changePage = (direction) => {
    if (direction === "up") {
      if (erledigtPage >= maxPage) return;
      setErledigtPagePage(erledigtPage + 1);
    }
    if (direction === "down") {
      if (erledigtPage === 1) return;
      setErledigtPagePage(erledigtPage - 1);
    }
  };

  return (
    <Fragment>
      <Page>
        <Layout>
          <ToDosNew aufgabenNeuLaden={() => getAufgaben()}></ToDosNew>

          <Tabs
            indicatorColor={"primary"}
            textColor={"primary"}
            value={uebersicht}
            onChange={(event, newValue) => {
              ansicht_aendern(newValue);
            }}
            variant="fullWidth"
          >
            <Tab label={t("Eigene offene")} />
            <Tab label={t("Eigene erledigte")} />
            <Tab label={t("Offene Erstellte")} />
          </Tabs>
        </Layout>

        {uebersicht !== 2 && (
          <Layout>
            {/* Desktop */}
            <Box sx={{ display: { xs: "none", sm: "none", md: "block" } }}>
              {filter == "E" && maxPage > 1 && (
                <Box sx={{ padding: 2 }}>
                  <Typography>
                    Seite {erledigtPage} von {maxPage}
                  </Typography>

                  <IconButton onClick={() => setErledigtPagePage(1)}>
                    <KeyboardDoubleArrowLeftIcon fontSize="inherit" />
                  </IconButton>
                  <IconButton onClick={() => changePage("down")}>
                    <KeyboardArrowLeftIcon fontSize="inherit" />
                  </IconButton>
                  <IconButton onClick={() => changePage("up")}>
                    <KeyboardArrowRightIcon fontSize="inherit" />
                  </IconButton>
                  <IconButton onClick={() => setErledigtPagePage(maxPage)}>
                    <KeyboardDoubleArrowRightIcon fontSize="inherit" />
                  </IconButton>
                </Box>
              )}

              <Grid container justifyContent="center" spacing={1} style={{ paddingTop: 20 }}>
                <Grid item xs={12} md={3}>
                  <SearchTextField
                    size="small"
                    fullWidth
                    label={t("Suche")}
                    id="filter"
                    variant="outlined"
                    value={suche}
                    inputProps={{
                      autoCapitalize: "off",
                      autoCorrect: "off",
                      spellCheck: "false",
                      autoComplete: "off",
                    }}
                    onChange={(e) => setSuche(e.target.value)}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    size="small"
                    type="date"
                    label={
                      filter === "O" ? "Aufgaben anzeigen, die bis zum [Datum] erledigt sein müssen" : "Aufgaben anzeigen welche an [Datum] erledigt wurden"
                    }
                    value={datumsFilter}
                    onChange={(e) => setDatumsFilter(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <Autocomplete
                    multiple
                    onChange={(event, newValue) => {
                      setMandantFilter(newValue);
                    }}
                    value={mandantFilter}
                    size="small"
                    id="tags-outlined"
                    options={mandantFilterOptions}
                    getOptionLabel={(option) => option.label}
                    renderInput={(params) => <TextField {...params} label="Nach Mandant filtern" placeholder="Mandant" />}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <Autocomplete
                    multiple
                    onChange={(event, newValue) => {
                      setAufgabenartFilter(newValue);
                    }}
                    value={aufgabenartFilter}
                    size="small"
                    id="tags-outlined"
                    options={aufgabenArtFilterOptions}
                    getOptionLabel={(option) => option.label}
                    renderInput={(params) => <TextField {...params} label="Nach Aufgabenart filtern" placeholder="Aufgabenart" />}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Mobile */}
            <Box sx={{ display: { xs: "block", sm: "block", md: "none" } }}>
              {filter == "E" && maxPage > 1 && (
                <Box sx={{ padding: 2 }}>
                  <Typography>
                    Seite {erledigtPage} von {maxPage}
                  </Typography>

                  <IconButton sx={{ marginRight: 2 }} onClick={() => setErledigtPagePage(1)}>
                    <KeyboardDoubleArrowLeftIcon fontSize="inherit" />
                  </IconButton>
                  <IconButton sx={{ marginRight: 2 }} onClick={() => changePage("down")}>
                    <KeyboardArrowLeftIcon fontSize="inherit" />
                  </IconButton>
                  <IconButton sx={{ marginRight: 2 }} onClick={() => changePage("up")}>
                    <KeyboardArrowRightIcon fontSize="inherit" />
                  </IconButton>
                  <IconButton sx={{ marginRight: 2 }} onClick={() => setErledigtPagePage(maxPage)}>
                    <KeyboardDoubleArrowRightIcon fontSize="inherit" />
                  </IconButton>
                </Box>
              )}

              <Box display="flex" alignItems={"center"}>
                <SearchTextField
                  size="small"
                  fullWidth
                  label={t("Suche")}
                  id="filter"
                  variant="outlined"
                  value={suche}
                  inputProps={{
                    autoCapitalize: "off",
                    autoCorrect: "off",
                    spellCheck: "false",
                    autoComplete: "off",
                  }}
                  onChange={(e) => setSuche(e.target.value)}
                />

                <Box pr={1}>
                  <Tooltip title="Filter">
                    <IconButton color="primary" onClick={() => setFilterDialog(true)}>
                      <FilterList />
                    </IconButton>
                  </Tooltip>
                </Box>

                <Dialog open={filterDialog} onClose={() => setFilterDialog(false)} maxWidth="md" fullWidth>
                  <DialogTitle>Filter</DialogTitle>
                  <DialogContent>
                    <Grid container justifyContent="center" spacing={1} style={{ paddingTop: 20 }}>
                      <Grid item xs={12} md={5}></Grid>
                      <Grid item xs={12} md={4}>
                        <TextField
                          fullWidth
                          size="small"
                          type="date"
                          label={
                            filter === "O"
                              ? "Aufgaben anzeigen, die bis zum [Datum] erledigt sein müssen"
                              : "Aufgaben anzeigen welche an [Datum] erledigt wurden"
                          }
                          value={datumsFilter}
                          onChange={(e) => setDatumsFilter(e.target.value)}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} md={2}>
                        <Autocomplete
                          multiple
                          onChange={(event, newValue) => {
                            setMandantFilter(newValue);
                          }}
                          value={mandantFilter}
                          size="small"
                          id="tags-outlined"
                          options={mandantFilterOptions}
                          getOptionLabel={(option) => option.label}
                          renderInput={(params) => <TextField {...params} label="Nach Mandant filtern" placeholder="Mandant" />}
                        />
                      </Grid>

                      <Grid item xs={12} md={3}>
                        <Autocomplete
                          multiple
                          onChange={(event, newValue) => {
                            setAufgabenartFilter(newValue);
                          }}
                          value={aufgabenartFilter}
                          size="small"
                          id="tags-outlined"
                          options={aufgabenArtFilterOptions}
                          getOptionLabel={(option) => option.label}
                          renderInput={(params) => <TextField {...params} label="Nach Aufgabenart filtern" placeholder="Aufgabenart" />}
                        />
                      </Grid>
                    </Grid>
                  </DialogContent>
                  <DialogActions>
                    <Button style={{ marginRight: "10px" }} variant="secondary" display="flex" onClick={() => setFilterDialog(false)}>
                      {t("Abbrechen")}
                    </Button>
                  </DialogActions>
                </Dialog>
              </Box>
            </Box>
            <TodoMain></TodoMain>
          </Layout>
        )}

        {uebersicht === 2 && <ToDosAdmin />}

        <MessageBox
          title={t("Aufgabe erledigt?")}
          text={t("Soll die Aufgabe zum heutigen Datum auf erledigt gesetzt werden?")}
          buttons="OKCANCEL"
          okText="Erledigt setzen"
          onClose={closeMessageBox}
          open={messageBoxOpen}
          handleResponse={messageBoxResult}
        />
      </Page>
    </Fragment>
  );
}

export default ToDos;
